import React, { Component } from 'react'
import {
    Autocomplete,
    FormControl,
    Select,
    MenuItem,
    TextField,
} from '@mui/material'

import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

const CURRENCY_OPTIONS = [
    { value: 'COP', name: 'Colombian Peso' },
    { value: 'CRC', name: 'Costa Rican Colón' },
    { value: 'EUR', name: 'Euro' },
    { value: 'GBP', name: 'British Pound Sterling' },
    { value: 'ILS', name: 'Israeli New Sheqel' },
    { value: 'INR', name: 'Indian Rupee' },
    { value: 'JPY', name: 'Japanese Yen' },
    { value: 'KRW', name: 'South Korean Won' },
    { value: 'MAD', name: 'Moroccan Dirham' },
    { value: 'NGN', name: 'Nigerian Naira' },
    { value: 'PYG', name: 'Paraguayan Guarani' },
    { value: 'PLN', name: 'Polish Zloty' },
    { value: 'THB', name: 'Thai Baht' },
    { value: 'USD', name: 'US Dollar' },
    { value: 'UAH', name: 'Ukrainian Hryvnia' },
    { value: 'VND', name: 'Vietnamese Dong' },
]

class DefFieldAmountSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currency:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.currency
                    ? this.props.item.settings.currency
                    : null,
            decimals:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.decimals
                    ? this.props.item.settings.decimals
                    : null,
            valueType:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.valueType
                    ? this.props.item.settings.valueType
                    : 'number',
        }
        this.onChange = this.onChange.bind(this)
    }

    onChange(event) {
        const { name, value } = event.target

        this.props.onChange(name, value)
        this.setState({ [name]: value })
    }

    render() {
        const { kedo } = this.props
        const { valueType, decimals, currency } = this.state
        return (
            <div>
                <h3>{this.props.kedo.t('Settings')}</h3>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{this.props.kedo.t('Type')}</FormInputLabel>
                    <Select
                        value={valueType ?? ''}
                        name="valueType"
                        onChange={this.onChange}
                        size="small"
                    >
                        <MenuItem value="currency">
                            {kedo.t('Currency')}
                        </MenuItem>
                        <MenuItem value="number">{kedo.t('Number')}</MenuItem>
                        <MenuItem value="percentage">
                            {kedo.t('Percentage')}
                        </MenuItem>
                    </Select>
                </FormControl>
                {this.state.valueType === 'currency' ||
                this.state.valueType === 'number' ? (
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {this.props.kedo.t('Decimals')}
                        </FormInputLabel>
                        <TextField
                            type="number"
                            name="decimals"
                            value={decimals ?? ''}
                            onChange={this.onChange}
                            fullWidth
                            size="small"
                        />
                    </FormControl>
                ) : null}
                {this.state.valueType === 'currency' ? (
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {this.props.kedo.t('Currency')}
                        </FormInputLabel>
                        <Autocomplete
                            size="small"
                            autoHighlight
                            options={CURRENCY_OPTIONS}
                            getOptionLabel={(option) => {
                                if (!option || typeof option === 'string') {
                                    return option || ''
                                }
                                return `${kedo.t(option.value)} ${option.name}`
                            }}
                            isOptionEqualToValue={(a, b) =>
                                a?.value === b?.value
                            }
                            value={
                                CURRENCY_OPTIONS.find(
                                    (option) => option.value === currency
                                ) || null
                            }
                            onChange={(_event, option) => {
                                const next = option ? option.value : ''
                                this.props.onChange('currency', next)
                                this.setState({
                                    currency: next === '' ? null : next,
                                })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    size="small"
                                    placeholder={kedo.t('Choose an option')}
                                />
                            )}
                        />
                    </FormControl>
                ) : null}
            </div>
        )
    }
}

export default DefFieldAmountSettings
